import React, { useState } from 'react'
import { CaretRight } from '@phosphor-icons/react'

interface CollapsibleSectionProps {
  title: string
  defaultOpen?: boolean
  badge?: string
  disabled?: boolean
  disabledHint?: string
  children: React.ReactNode
}

export default function CollapsibleSection({
  title,
  defaultOpen = false,
  badge,
  disabled = false,
  disabledHint,
  children,
}: CollapsibleSectionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen && !disabled)

  return (
    <div className="border-t border-border/50">
      <button
        type="button"
        onClick={() => !disabled && setIsOpen(!isOpen)}
        className={`w-full flex items-center justify-between px-4 py-3 ${
          disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer hover:bg-accent/30'
        } transition-colors`}
      >
        <div className="flex items-center gap-1.5">
          <CaretRight
            className={`w-3.5 h-3.5 text-muted-foreground transition-transform duration-200 ${isOpen ? 'rotate-90' : ''}`}
          />
          <span className="text-xs font-emphasis text-muted-foreground uppercase tracking-wider">
            {title}
          </span>
        </div>
        {badge && !disabled && (
          <span className="text-[10px] bg-primary/15 text-primary px-2 py-0.5 rounded-full font-medium">
            {badge}
          </span>
        )}
        {disabled && disabledHint && (
          <span className="text-[10px] bg-muted text-muted-foreground px-2 py-0.5 rounded-full">
            {disabledHint}
          </span>
        )}
      </button>
      {isOpen && !disabled && (
        <div className="px-4 pb-4">
          {children}
        </div>
      )}
    </div>
  )
}
